<template>
  <div>
    <div v-if="column.field==='operation'&&!isTop">
      <el-link @click="openFile(row)">预览</el-link>
      <el-link v-if="row.deleteStatus===0&&row.publishStatus===0&&(row.reviewStatus===null||row.reviewStatus===2)" @click="editObject(row)">编辑</el-link>
      <el-link v-if="row.deleteStatus===0&&row.publishStatus===0&&(row.reviewStatus===null||row.reviewStatus===2)" @click="batchUpdateStatus(row.id,'send')">送审核</el-link>
      <el-link v-if="roles.indexOf('article_audit')>-1&&row.deleteStatus===0&&row.publishStatus===1" @click="batchUpdateStatus(row.id,'cancelPublish')">取消发布</el-link>
      <!-- <el-link v-if="row.deleteStatus===0&&row.publishStatus===0&&row.reviewStatus===0" @click="batchUpdateStatus(row.id,'review')">审核通过</el-link>
      <el-link v-if="row.deleteStatus===0&&row.publishStatus===0&&row.reviewStatus===0" @click="batchUpdateStatus(row.id,'reject')">审核不通过</el-link> -->
      <el-link v-if="roles.indexOf('article_audit')>-1&&row.deleteStatus===0&&row.publishStatus===0&&row.reviewStatus===0" @click="editObject(row,'shenhe')">审核</el-link>
      <el-link v-if="roles.indexOf('article_audit')>-1&&row.deleteStatus===0&&row.publishStatus===0&&row.reviewStatus===1" @click="batchUpdateStatus(row.id,'publish')">发布</el-link>
      <el-link v-if="row.deleteStatus===0&&roles.indexOf('article_audit')===-1&&row.reviewStatus!==null" @click="batchUpdateStatus(row.id,'delete')">删除</el-link>
    </div>
    <div v-if="column.field==='operation'&&isTop">
      <el-link v-if="row.reviewStatus===0" @click="editObject(row,'shenhe')">审核</el-link>
      <el-link v-else @click="cancelTop(row)">取消头条</el-link>
    </div>
    <div v-if="column.field==='publishStatus'">
      <span v-if="row.deleteStatus===1">已删除</span>
      <span v-if="row.deleteStatus===0&&row.publishStatus===1&&row.reviewStatus!==2">已发布</span>
      <span v-if="row.deleteStatus===0&&row.reviewStatus===1&&row.publishStatus===0">待发布</span>
      <span v-if="row.deleteStatus===0&&row.reviewStatus===null">草稿</span>
      <span v-if="row.deleteStatus===0&&row.reviewStatus===0&&row.publishStatus===0">待审核</span>
      <span v-if="row.deleteStatus===0&&row.reviewStatus===2">审核不通过</span>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        column: { type: Object, default: null },
        row: { type: Object, default: null },
        index: { type: Number, default: null }
    },
    data() {
        return {
            isTop: false,
            roles: []
        }
    },
    created() {
        this.roles = this.$store.state.user.roles
        if (this.$route.meta.params.indexOf('isHeadlines') > -1) {
            this.isTop = true
        }
    },
    methods: {
        editObject(row, type) {
            window.open('/#/article?type=' + row.type + '&canEdit=' + (type === 'shenhe' ? 0 : 1) + '&id=' + row.id)
        },
        batchUpdateStatus(id, status) {
            this.$nextTick(() => {
                this.$bus.emit('batchUpdateStatus', id, status)
            })
        },
        // 预览
        openFile(row) {
            if (row.id) {
                window.open('/#/commonHeader?workform=@/wapp/common/components/viewContent/index&background=false&wflowType=getById&wfEngineUrl=portal/cms/article&busiDataId=' + row.id + '&viewContent=1' + '&type=zsgl&logoTitle=' + encodeURIComponent(`信息共享/新闻中心`))
            }
        },
        cancelTop(row) {
            this.$confirm('确定要取消头条吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.isHeadlines = 0
                this.$http({
                    method: 'PUT',
                    url: 'portal/cms/article/update',
                    data: row
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message({
                            message: '取消成功',
                            type: 'success'
                        })
                        this.$nextTick(() => {
                            this.$bus.emit('refreshListData')
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch({})
        }
    }
}
</script>

<style scoped lang="scss">

</style>
